@if (isUsingWallet()) {
  <div class="wallet-iframe-container" [class.hidden]="!showWallet()">
    <button
      class="close-button"
      type="button"
      aria-label="Close wallet"
      (click)="closeWallet()"
    >
      ×
    </button>
    <iframe
      #kaspaComWebWallet
      class="wallet-iframe"
      [src]="iframeUrl"
      title="KaspaCom Web Wallet"
      allow="camera; clipboard-write"
      sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
    ></iframe>
  </div>
}
